var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecordIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "31px",
    height: "31px",
    viewBox: "0 0 31 31",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1A4D84DE-CD80-40F6-9CA8-9DEADF7E9B70") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.070588 0 0 0 0 0.415686 0 0 0 0 0.541176 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TurnItBlue---Milestone-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "13.0_My-Library_11.1",
    transform: "translate(-280.000000, -414.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "info",
    transform: "translate(260.000000, 382.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.000000, 32.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3125,2.5 L13.9375,2.5 C13.525,1.0625 12.2,0 10.625,0 C9.05,0 7.725,1.0625 7.3125,2.5 L5.9375,2.5 C5.425,2.5 5,2.925 5,3.4375 L5,5.3125 C5,6.5125 5.9875,7.5 7.1875,7.5 L14.0625,7.5 C15.2625,7.5 16.25,6.5125 16.25,5.3125 L16.25,3.4375 C16.25,2.925 15.825,2.5 15.3125,2.5 Z",
    id: "Path",
    fill: "currentColor",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8125,3.75 L17.5,3.75 L17.5,5.3125 C17.5,7.2125 15.9625,8.75 14.0625,8.75 L7.1875,8.75 C5.2875,8.75 3.75,7.2125 3.75,5.3125 L3.75,3.75 L3.4375,3.75 C1.5375,3.75 0,5.2875 0,7.1875 L0,22.8125 C0,24.7125 1.5375,26.25 3.4375,26.25 L11.675,26.25 C11.05,24.9125 10.675,23.4375 10.6375,21.875 L4.6875,21.875 C4.175,21.875 3.75,21.45 3.75,20.9375 C3.75,20.425 4.175,20 4.6875,20 L10.7375,20 C10.85,19.2375 11.0375,18.5125 11.2875,17.8125 L4.6875,17.8125 C4.175,17.8125 3.75,17.3875 3.75,16.875 C3.75,16.3625 4.175,15.9375 4.6875,15.9375 L12.1875,15.9375 C12.675,15.1375 13.25,14.4 13.925,13.75 L4.6875,13.75 C4.175,13.75 3.75,13.325 3.75,12.8125 C3.75,12.3 4.175,11.875 4.6875,11.875 L16.4875,11.875 C17.925,11.125 19.5375,10.675 21.25,10.6375 L21.25,7.1875 C21.25,5.2875 19.7125,3.75 17.8125,3.75 Z",
    id: "Path",
    fill: "currentColor",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5625,13.125 C16.91,13.125 13.125,16.91 13.125,21.5625 C13.125,26.215 16.91,30 21.5625,30 C26.215,30 30,26.215 30,21.5625 C30,16.91 26.215,13.125 21.5625,13.125 Z M22.8125,25 C22.8125,25.69 22.25375,26.25 21.5625,26.25 C20.87125,26.25 20.3125,25.69 20.3125,25 L20.3125,20.625 C20.3125,19.935 20.87125,19.375 21.5625,19.375 C22.25375,19.375 22.8125,19.935 22.8125,20.625 L22.8125,25 Z M21.5625,18.75 C20.8725,18.75 20.3125,18.19 20.3125,17.5 C20.3125,16.81 20.8725,16.25 21.5625,16.25 C22.2525,16.25 22.8125,16.81 22.8125,17.5 C22.8125,18.19 22.2525,18.75 21.5625,18.75 Z",
    id: "Shape",
    fill: "currentColor",
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecordIcon);
export default __webpack_public_path__ + "static/media/RecordIcon.c2cc9b1406f66baa46827e06b8751bed.svg";
export { ForwardRef as ReactComponent };